<div class="slider">
  <div class="custom-slider">
    <ngx-slider [(value)]="filterOption!.currentMinValue!" [(highValue)]="filterOption!.currentMaxValue!" [options]="options"></ngx-slider>
  </div>
  <div class="value-wrapper">
    <div class="value min-value">
      <input type="number" [ngModel]="filterOption!.currentMinValue" (change)="setValue($event, 'currentMinValue', 'minValue')" />
      <span class="extension">{{ currency }}</span>
    </div>
    <span>-</span>
    <div class="value max-value">
      <input type="number" [ngModel]="filterOption!.currentMaxValue" (change)="setValue($event, 'currentMaxValue', 'maxValue')" />
      <span class="extension">{{ currency }}</span>
    </div>
  </div>
</div>
